import { BehavioralVerb } from 'apps/web/types/labelled-collection.type';
import { createOptions } from 'apps/web/types/option';

export const DIGITAL_REMEMBERING_VERBS: BehavioralVerb[] = createOptions([
  'Bookmarking',
  'Copying',
  'Defining',
  'Finding',
  'Googling',
  'Highlighting',
  'Identifying',
  'Listening',
  'Locating',
  'Memorizing',
  'Outlining',
  'Quoting',
  'Repeating',
  'Retrieving',
  'Searching',
]);

export const DIGITAL_UNDERSTANDING_VERBS: BehavioralVerb[] = createOptions([
  'Annotate',
  'Associate',
  'Categorizing',
  'Commenting',
  'Comparing',
  'Expressing',
  'Interpreting',
  'Journaling',
  'Paraphrasing',
  'Predicting',
  'Relating',
  'Summarizing',
  'Tagging',
  'Tweeting',
]);

export const DIGITAL_APPLYING_VERBS: BehavioralVerb[] = createOptions([
  'Acting out',
  'Articulate',
  'Charting',
  'Choosing',
  'Determining',
  'Displaying',
  'Keywords',
  'Loading',
  'Playing',
  'Presenting',
  'Reenact',
  'Revising',
  'Searching',
  'Sketching',
]);

export const DIGITAL_ANALYZING_VERBS: BehavioralVerb[] = createOptions([
  'Advertising',
  'Appraising',
  'Breaking Down',
  'Calculating',
  'Correlating',
  'Deconstructing',
  'Deducting',
  'Dividing',
  'Hyperlinking',
  'Mind-Mapping',
  'Structuring',
  'Supporting',
]);

export const DIGITAL_EVALUATING_VERBS: BehavioralVerb[] = createOptions([
  'Arguing',
  'Assessing',
  'Criticizing',
  'Debating',
  'Defending',
  'Editorializing',
  'Judging',
  'Pivoting',
  'Rating',
  'Reflecting',
  'Reviewing',
  'Scoring',
  'Testing',
  'Validating',
]);

export const DIGITAL_CREATING_VERBS: BehavioralVerb[] = createOptions([
  'Animating',
  'Blogging',
  'Collaborating',
  'Composing',
  'Designing',
  'Developing',
  'Directing',
  'Facilitating',
  'Podcasting',
  'Programming',
  'Remixing',
  'Simulating',
  'Wiki Building',
  'Writing',
]);
